import Spinner from 'components/spinner/spinner.component';
import Cookies from 'js-cookie';
import Clover from 'pages/clover/clover.component';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { getAnalytics } from 'util/analytics';
import { actions, selectors } from '../../redux/client/client.slice';

import DynamicClientContainer from './dynamic-client.container';
import StaticClientContainer from './static-client.container';
import NotFound from 'components/not-found/not-found.component';
import SpreedlyPaymentPageHosted from 'pages/spreedly-payment-hosted/spreedly-payment-page-hosted/spreedly-payment-page-hosted.component';
import SpreedlyCVVRecacheHosted from 'pages/spreedly-payment-hosted/spreedly-cvv-recache-hosted/spreedly-cvv-recache-hosted.component';
import { usePaymentsRouteMatch } from './client.hooks';

const ClientContainer = () => {
  const dispatch = useDispatch();
  const [isCustomDomain, setIsCustomDomain] = useState(false);
  const staticClient = useMemo(() => Cookies.get('INC_STATIC_CLIENT'), []);
  const matchDynamic = useRouteMatch({
    path: ['/c/:clientAlias', '/test/c/:clientAlias'],
  });
  const paymentsRouteMatch = usePaymentsRouteMatch();
  const matchTest = useRouteMatch('/test');
  const history = useHistory();
  const clientAlias = useMemo(
    () => staticClient ?? matchDynamic?.params?.clientAlias,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  const clientId = useSelector(selectors.selectClientId);
  const clientError = useSelector(selectors.selectError);
  const [awaitRedirect, setAwaitRedirect] = useState(false);

  useEffect(() => {
    if (clientAlias) {
      if (staticClient) setAwaitRedirect(true);
      dispatch(actions.fetchClientId(clientAlias)).then(data => {
        if (data.error) {
          return;
        }
        getAnalytics().clientGroup(data?.payload?.clientId, clientAlias);
        if (staticClient && !!matchDynamic) {
          if (!!matchTest) history.replace('/test');
          else history.replace('/');
        }
        setAwaitRedirect(false);
      });
      return;
    } else if (paymentsRouteMatch) {
      return;
    } else {
      setAwaitRedirect(true);
      dispatch(actions.fetchClientFromDomain(window.location.hostname))
        .then(data => {
          if (data.error) {
            return;
          }
          setIsCustomDomain(true);
          getAnalytics().clientGroup(
            data?.payload?.clientId,
            data?.payload?.clientAlias,
          );
        })
        .finally(() => {
          setAwaitRedirect(false);
        });
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (clientError) return <NotFound />;

  if (!paymentsRouteMatch && (!clientId || awaitRedirect)) return <Spinner />;

  if (staticClient || isCustomDomain)
    return (
      <Switch>
        <Route path={['/', '/test']} component={StaticClientContainer} />
      </Switch>
    );

  return (
    <Switch>
      <Route path="/c/:clientAlias/payments/clover" component={Clover} />
      <Route path="/payments/spreedly" component={SpreedlyPaymentPageHosted} />
      <Route
        path="/payments/spreedlycvvrecache"
        component={SpreedlyCVVRecacheHosted}
      />
      <Route
        path={['/c/:clientAlias', '/test/c/:clientAlias']}
        component={DynamicClientContainer}
      />
    </Switch>
  );
};

export default ClientContainer;
